let Vue = null;

function vueSet(array, key, value) {
  if (Vue) {
    Vue.set(array, key, value);
  } else {
    array[key] = value;
  }
}

function vueDelete(array, key) {
  if (Vue) {
    Vue.delete(array, key);
  } else {
    delete array[key];
  }
}

export default {
  namespaced: true,
  state: {
    items: {}
  },
  init: function (vue, store) {
    Vue = vue;
  },
  mutations: {
    addError(state, error) {
      error.timestamp = Date.now();
      if (error.exceptionData) {
        state.items[error.exceptionData.id] = error;
      }
    },
    setError(state, { id, error }) {
      error.timestamp = Date.now();
      vueSet(state.items, id, error);
    },
    updateError(state, { id, message, level }) {
      var error = state.items[id];
      error.timestamp = Date.now();
      error.message = message;
      error.level = level;
      vueSet(state.items, id, error);
    },
    removeError(state, { id }) {
      vueDelete(state.items, id);
    }
  },
  getters: {
    getErrors: state => {
      let items = state.items;
      return Object.keys(items).map(function (key) {
        return items[key];
      });
    }
  },
  actions: {
    add(context, { message }) {
      var id = uuidv4();
      var error = {
        id: id,
        level: 1,
        message: message
      };
      context.commit('setError', { id, error });
    },
    addError(context, { id, error }) {
      context.commit('setError', { id, error });
    },
    updateError(context, { id, message, level }) {
      context.commit('updateError', { id, message, level });
    },
    removeError(context, { id }) {
      context.commit('removeError', { id });
    }
  }
};

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/store/errors.js
// module id = null
// module chunks = 